'use client';
import * as React from 'react';
import { Tabs } from '@base-ui/react/tabs';
import * as CodeBlock from '../CodeBlock';
import { Code } from '../Code';
import './CodeTabs.css';

interface HighlightedTab {
  label: string;
  language: string;
  html: string;
}

interface CodeTabsClientProps {
  tabs: HighlightedTab[];
  title?: string;
  className?: string;
}

export function CodeTabsClient({ tabs, title = 'Code example', className }: CodeTabsClientProps) {
  const [value, setValue] = React.useState(tabs[0]?.label ?? '');

  return (
    <Tabs.Root className={className} value={value} onValueChange={setValue}>
      <CodeBlock.Root>
        <CodeBlock.Panel title={title}>
          <Tabs.List className="CodeTabsList" aria-label="Programming language">
            {tabs.map((tab) => (
              <Tabs.Tab key={tab.label} value={tab.label} className="CodeTabsTab">
                <span className="CodeTabsTabLabel" data-text={tab.label}>
                  {tab.label}
                </span>
              </Tabs.Tab>
            ))}
          </Tabs.List>
        </CodeBlock.Panel>

        {tabs.map((tab) => (
          <Tabs.Panel key={tab.label} value={tab.label}>
            <CodeBlock.Pre data-language={tab.language}>
              <Code data-language={tab.language}>
                <span dangerouslySetInnerHTML={{ __html: tab.html }} />
              </Code>
            </CodeBlock.Pre>
          </Tabs.Panel>
        ))}
      </CodeBlock.Root>
    </Tabs.Root>
  );
}
